import { launch } from './launch';
import { lifecycle } from './lifecycle';
import { tags$ } from './tag';

// Application entry point
launch();

// Hand tag$ stream off to lifecycle listeners to control what happens
// based on session events (e.g. resize, unload)
lifecycle(tags$);
